import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f76d1dc6")

_pushScopeId("data-v-f76d1dc6")
const _hoisted_1 = { class: "container home-news" }
const _hoisted_2 = { class: "col-12 col-md-7" }
const _hoisted_3 = { class: "home-news__content" }
const _hoisted_4 = { class: "home-news__date" }
const _hoisted_5 = { class: "home-news__title" }
const _hoisted_6 = { class: "btn home-news__btn" }
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  width: "34",
  height: "12",
  viewBox: "0 0 34 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M28.1529 1.19458L32.9583 6L28.1529 10.8054M1 6H32.8237",
    "stroke-width": "1.5",
    "stroke-miterlimit": "10",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_8 = { class: "col-12 col-md-5" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.articles, (article) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: article.id,
        to: {
      name: 'singlenews',
      params: { newsId: article.id }
    },
        class: "row overlay home-news__row"
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('labels.fromTourstat', [' | ' + article.created_at])), 1),
              _createVNode("div", _hoisted_5, _toDisplayString(article.title), 1),
              _createVNode("div", null, [
                _createVNode("button", _hoisted_6, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('labels.next')), 1),
                  _hoisted_7
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("img", {
              src: $setup.getFile(article.image),
              alt: "",
              class: "home-news__img"
            }, null, 8, ["src"])
          ])
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})